module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesLuxury.5ab4724.webp";